import React from "react";
import { Select, SelectVariant } from "@patternfly/react-core";

export default class SingleSelectInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selected: props.selected ? props.selected : null,
    };

    this.onToggle = (isOpen) => {
      this.setState({
        isOpen,
      });
    };

    this.onSelect = (event, selection) => {
      this.setState({
        selected: selection,
        isOpen: false,
      });
      this.props.onSelect(selection);
    };
  }

  render() {
    const { isOpen, selected } = this.state;
    const titleId = "title-id";
    return (
      <div>
        <span id={titleId} hidden>
          Title
        </span>
        <Select
          variant={SelectVariant.single}
          aria-label="Select Input"
          onToggle={this.onToggle}
          onSelect={this.onSelect}
          selections={selected}
          isOpen={isOpen}
          aria-labelledby={titleId}
        >
          {this.props.options}
        </Select>
      </div>
    );
  }
}
